export const imagesArch = {
  "pr3-stade": {
    id: "pr3-stade",
    cover: "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-1.jpg",
    pictures: [
      "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-1.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr3/pr3-stade-1.webp",
      "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-1.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr3/pr3-stade-1.jpg",
      "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-2.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr3/pr3-stade-2.webp",
      "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-2.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr3/pr3-stade-2.jpg",
      "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-3.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr3/pr3-stade-3.webp",
      "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-3.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr3/pr3-stade-3.jpg",
      "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-4.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr3/pr3-stade-4.webp",
      "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-4.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr3/pr3-stade-4.jpg",
      "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-5.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr3/pr3-stade-5.webp",
      "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-5.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr3/pr3-stade-5.jpg",
      "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-6.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr3/pr3-stade-6.webp",
      "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-6.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr3/pr3-stade-6.jpg",
      "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-7.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr3/pr3-stade-7.webp",
      "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-7.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr3/pr3-stade-7.jpg",
      "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-8.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr3/pr3-stade-8.webp",
      "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-8.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr3/pr3-stade-8.jpg",
      "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-10.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr3/pr3-stade-10.webp",
      "https://cv-api-omega.vercel.app/arch/pr3/pr3-stade-10.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr3/pr3-stade-10.jpg",
    ],
  },
  "pr-maison-perso": {
    id: "pr-maison-perso",
    cover: "https://cv-api-omega.vercel.app/arch/pr1/pr1-1.jpg",
    pictures: [
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-1.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-1.webp",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-1.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-1.jpg",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-2.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-2.webp",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-2.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-2.jpg",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-3.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-3.webp",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-3.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-3.jpg",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-4.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-4.webp",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-4.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-4.jpg",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-5.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-5.webp",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-5.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-5.jpg",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-6.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-6.webp",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-6.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-6.jpg",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-7.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-7.webp",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-7.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-7.jpg",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-8.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-8.webp",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-8.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-8.jpg",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-9.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-9.webp",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-9.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-9.jpg",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-10.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-10.webp",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-10.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-10.jpg",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-11.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-11.webp",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-11.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-11.jpg",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-12.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-12.webp",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-12.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-12.jpg",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-13.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-13.webp",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-13.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-13.jpg",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-14.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-14.webp",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-14.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-14.jpg",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-15.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-15.webp",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-15.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-15.jpg",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-16.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-16.webp",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-16.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-16.jpg",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-17.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-17.webp",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-17.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-17.jpg",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-18.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-18.webp",
      "https://cv-api-omega.vercel.app/arch/pr0/pr0-18.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr0/pr0-18.jpg",
    ],
  },
  "pr1-maison": {
    id: "pr1-maison",
    cover: "https://cv-api-omega.vercel.app/arch/pr1/pr1-1.jpg",
    pictures: [
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-0.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-0.webp",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-0.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-0.jpg",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-1.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-1.webp",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-1.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-1.jpg",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-2.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-2.webp",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-2.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-2.jpg",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-3.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-3.webp",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-3.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-3.jpg",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-4.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-4.webp",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-4.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-4.jpg",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-5.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-5.webp",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-5.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-5.jpg",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-6.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-6.webp",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-6.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-6.jpg",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-7.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-7.webp",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-7.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-7.jpg",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-8.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-8.webp",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-8.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-8.jpg",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-9.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-9.webp",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-9.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-9.jpg",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-10.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-10.webp",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-10.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-10.jpg",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-11.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-11.webp",
      "https://cv-api-omega.vercel.app/arch/pr1/pr1-11.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr1/pr1-11.jpg",
    ],
  },
  "pr2-maison": {
    id: "pr2-maison",
    cover: "https://cv-api-omega.vercel.app/arch/pr2/pr2-1.jpg",
    pictures: [
      "https://cv-api-omega.vercel.app/arch/pr2/pr2-1.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr2/pr2-1.webp",
      "https://cv-api-omega.vercel.app/arch/pr2/pr2-1.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr2/pr2-1.jpg",
      "https://cv-api-omega.vercel.app/arch/pr2/pr2-2.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr2/pr2-2.webp",
      "https://cv-api-omega.vercel.app/arch/pr2/pr2-2.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr2/pr2-2.jpg",
      "https://cv-api-omega.vercel.app/arch/pr2/pr2-3.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr2/pr2-3.webp",
      "https://cv-api-omega.vercel.app/arch/pr2/pr2-3.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr2/pr2-3.jpg",
      "https://cv-api-omega.vercel.app/arch/pr2/pr2-4.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr2/pr2-4.webp",
      "https://cv-api-omega.vercel.app/arch/pr2/pr2-4.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr2/pr2-4.jpg",
      "https://cv-api-omega.vercel.app/arch/pr2/pr2-5.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr2/pr2-5.webp",
      "https://cv-api-omega.vercel.app/arch/pr2/pr2-5.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr2/pr2-5.jpg",
      "https://cv-api-omega.vercel.app/arch/pr2/pr2-6.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr2/pr2-6.webp",
      "https://cv-api-omega.vercel.app/arch/pr2/pr2-6.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr2/pr2-6.jpg",
    ],
  },
  "pr3A-maison": {
    id: "pr3A-maison",
    cover: "https://cv-api-omega.vercel.app/arch/pr2/pr2-1.jpg",
    pictures: [
      "https://cv-api-omega.vercel.app/arch/pr3A/pr3A-1.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr3A/pr3A-1.webp",
      "https://cv-api-omega.vercel.app/arch/pr3A/pr3A-1.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr3A/pr3A-1.jpg",
      "https://cv-api-omega.vercel.app/arch/pr3A/pr3A-2.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr3A/pr3A-2.webp",
      "https://cv-api-omega.vercel.app/arch/pr3A/pr3A-2.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr3A/pr3A-2.jpg",
      "https://cv-api-omega.vercel.app/arch/pr3A/pr3A-3.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr3A/pr3A-3.webp",
      "https://cv-api-omega.vercel.app/arch/pr3A/pr3A-3.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr3A/pr3A-3.jpg",
      "https://cv-api-omega.vercel.app/arch/pr3A/pr3A-4.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr3A/pr3A-4.webp",
      "https://cv-api-omega.vercel.app/arch/pr3A/pr3A-4.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr3A/pr3A-4.jpg",
      "https://cv-api-omega.vercel.app/arch/pr3A/pr3A-5.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr3A/pr3A-5.webp",
      "https://cv-api-omega.vercel.app/arch/pr3A/pr3A-5.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr3A/pr3A-5.jpg",
      "https://cv-api-omega.vercel.app/arch/pr3A/pr3A-6.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr3A/pr3A-6.webp",
      "https://cv-api-omega.vercel.app/arch/pr3A/pr3A-6.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr3A/pr3A-6.jpg",
      "https://cv-api-omega.vercel.app/arch/pr3A/pr3A-7.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr3A/pr3A-7.webp",
      "https://cv-api-omega.vercel.app/arch/pr3A/pr3A-7.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr3A/pr3A-7.jpg",
    ],
  },
  "pr4-cinema": {
    id: "pr4-cinema",
    cover: "https://cv-api-omega.vercel.app/arch/pr4/pr4-0.jpg",
    pictures: [
      "https://cv-api-omega.vercel.app/arch/pr4/pr4-0.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr4/pr4-0.webp",
      "https://cv-api-omega.vercel.app/arch/pr4/pr4-0.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr4/pr4-0.jpg",
      "https://cv-api-omega.vercel.app/arch/pr4/pr4-1.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr4/pr4-1.webp",
      "https://cv-api-omega.vercel.app/arch/pr4/pr4-1.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr4/pr4-1.jpg",
      "https://cv-api-omega.vercel.app/arch/pr4/pr4-2.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr4/pr4-2.webp",
      "https://cv-api-omega.vercel.app/arch/pr4/pr4-2.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr4/pr4-2.jpg",
      "https://cv-api-omega.vercel.app/arch/pr4/pr4-3.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr4/pr4-3.webp",
      "https://cv-api-omega.vercel.app/arch/pr4/pr4-3.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr4/pr4-3.jpg",
      "https://cv-api-omega.vercel.app/arch/pr4/pr4-4.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr4/pr4-4.webp",
      "https://cv-api-omega.vercel.app/arch/pr4/pr4-4.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr4/pr4-4.jpg",
    ],
  },
  "pr5-reconstruction": {
    id: "pr5-reconstruction",
    cover: "https://cv-api-omega.vercel.app/arch/pr5/pr5-1.png",
    pictures: [
      "https://cv-api-omega.vercel.app/arch/pr5/pr5-3.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr5/pr5-3.webp",
      "https://cv-api-omega.vercel.app/arch/pr5/pr5-3.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr5/pr5-3.jpg",
      "https://cv-api-omega.vercel.app/arch/pr5/pr5-1.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr5/pr5-1.webp",
      "https://cv-api-omega.vercel.app/arch/pr5/pr5-1.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr5/pr5-1.jpg",
      "https://cv-api-omega.vercel.app/arch/pr5/pr5-2.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr5/pr5-2.webp",
      "https://cv-api-omega.vercel.app/arch/pr5/pr5-2.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr5/pr5-2.jpg",
      "https://cv-api-omega.vercel.app/arch/pr5/pr5-4.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr5/pr5-4.webp",
      "https://cv-api-omega.vercel.app/arch/pr5/pr5-4.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr5/pr5-4.jpg",
      "https://cv-api-omega.vercel.app/arch/pr5/pr5-5.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr5/pr5-5.webp",
      "https://cv-api-omega.vercel.app/arch/pr5/pr5-5.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr5/pr5-5.jpg",
      "https://cv-api-omega.vercel.app/arch/pr5/pr5-6.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr5/pr5-6.webp",
      "https://cv-api-omega.vercel.app/arch/pr5/pr5-6.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr5/pr5-6.jpg",
    ],
  },
  "pr6-urbanime": {
    id: "pr6-urbanime",
    cover: "https://cv-api-omega.vercel.app/arch/pr6/pr6-1.jpg",
    pictures: [
      "https://cv-api-omega.vercel.app/arch/pr6/pr6-1.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr6/pr6-1.webp",
      "https://cv-api-omega.vercel.app/arch/pr6/pr6-1.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr6/pr6-1.jpg",
    ],
  },
  "pr7-sistematisation-verticale": {
    id: "pr7-sistematisation-verticale",
    cover: "https://cv-api-omega.vercel.app/arch/pr7/pr7-1.jpg",
    pictures: [
      "https://cv-api-omega.vercel.app/arch/pr7/pr7-1.webp",
      "https://boogysh.github.io/cv-api/images/arch/pr7/pr7-1.webp",
      "https://cv-api-omega.vercel.app/arch/pr7/pr7-1.jpg",
      "https://boogysh.github.io/cv-api/images/arch/pr7/pr7-1.jpg",
    ],
  },
};
